import React from 'react';
import LegalLayout, { Section } from '../components/fancyplants/LegalLayout';

const CookiesNotice = () => (
  <LegalLayout
    eyebrow="Legal"
    title="Cookies Notice"
    intro="How we use cookies on the Fancy Plants site — and how you stay in control."
    updated="May 2026"
  >
    <Section heading="What cookies are">
      <p>
        Cookies are small text files stored on your device when you visit a website. They help the
        site work and, with your permission, help us understand how it's used.
      </p>
    </Section>

    <Section heading="Essential cookies">
      <p>
        Necessary for the site to function — keeping your basket, remembering your cookie choice,
        and security. These are always on and don't require consent.
      </p>
      <ul>
        <li><strong>fp_cart_v1</strong> — remembers what's in your basket (stored locally on your device).</li>
        <li><strong>cookie_consent</strong> — remembers your cookie preferences.</li>
      </ul>
    </Section>

    <Section heading="Analytics cookies (consent required)">
      <p>
        Only set if you accept them. They tell us, anonymously, which pages and plants are popular
        so we can improve the shop. No analytics or non-essential cookies run before you consent.
      </p>
    </Section>

    <Section heading="Managing your choices">
      <p>
        You can accept or reject non-essential cookies from the banner when you first visit, and
        change your mind at any time via the cookie settings. You can also clear cookies in your
        browser settings.
      </p>
    </Section>

    <Section heading="Contact">
      <p>
        Questions about cookies or your data? Email{' '}
        <a href="mailto:hello@fancyplants.ie" className="link-underline">hello@fancyplants.ie</a>.
      </p>
    </Section>
  </LegalLayout>
);

export default CookiesNotice;
